import React from "react";
import { useIntl } from "react-intl";
import AlertTitle from "../../Unknown/AlertTitle";
import Typography from "../../Unknown/Typography";
import Alert from "../../Unknown/Alert";
import useStyles from "./useStyles";
import messages from "./messages";
import { formatInternational } from "../../../common/phoneNumberHelpers";

export type PatientAgeAlertType = "online_booking" | "self_booking";

interface PatientAgeAlertProps {
  type: PatientAgeAlertType;
  minOnlineBookingAge: number;
  minSelfBookingAge: number;
  centerPhone: string;
  centerName: string;
}

export const PatientAgeAlert: React.FC<PatientAgeAlertProps> = ({
  type,
  minOnlineBookingAge,
  minSelfBookingAge,
  centerName,
  centerPhone,
}) => {
  const { alertRoot } = useStyles();
  const { formatMessage } = useIntl();

  const alertProps: Record<
    PatientAgeAlertType,
    { title: string; description: React.ReactNode }
  > = {
    online_booking: {
      title: formatMessage(messages.onlineBookingTitle),
      description: formatMessage(messages.onlineBookingDescription, {
        minOnlineBookingAge,
        centerName,
        centerPhone: (
          <Typography
            component="span"
            variant="body2"
            color="inherit"
            fontWeight="700"
          >
            {formatInternational({ phoneNumber: centerPhone })}
          </Typography>
        ),
      }),
    },
    self_booking: {
      title: formatMessage(messages.selfBookingTitle),
      description: formatMessage(messages.selfBookingDescription, {
        minSelfBookingAge,
      }),
    },
  };

  return (
    <Alert severity="error" classes={{ root: alertRoot }}>
      <AlertTitle>{alertProps[type].title}</AlertTitle>
      <Typography variant="body2" fontSize={14} color="inherit">
        {alertProps[type].description}
      </Typography>
    </Alert>
  );
};
